
import { Vue, Component, Prop } from 'vue-property-decorator';
import { types } from '../../api_types';
import * as time from '../../time';
import * as ui from '../../ui';
import T from '../../lang';
import omegaup_Countdown from '../Countdown.vue';
import { omegaup } from '../../omegaup';
import { getExternalUrl } from '../../urlHelper';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

import { LayoutPlugin, CollapsePlugin } from 'bootstrap-vue';
Vue.use(LayoutPlugin);
Vue.use(CollapsePlugin);

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
library.add(fas);

@Component({
  components: {
    FontAwesomeIcon,
    'omegaup-countdown': omegaup_Countdown,
  },
})
export default class UserNextRegisteredContest extends Vue {
  @Prop() nextRegisteredContest!: types.ContestListItem;
  T = T;
  ui = ui;
  omegaup = omegaup;
  showContestInfo = true;
  now = new Date();

  get contestDuration(): string {
    return time.formatContestDuration(
      this.nextRegisteredContest.start_time,
      this.nextRegisteredContest.finish_time,
    );
  }

  get startContestDate(): string {
    return `${this.nextRegisteredContest.start_time.toLocaleDateString()} ${this.nextRegisteredContest.start_time.toLocaleTimeString()}`;
  }

  get startTimeLink(): string {
    return `${getExternalUrl(
      'TimeAndDateBaseURL',
    )}?iso=${this.nextRegisteredContest.start_time.toISOString()}`;
  }

  get isContestStarted(): boolean {
    return this.nextRegisteredContest.start_time < this.now;
  }

  onClick(): void {
    this.showContestInfo = false;
    this.$emit('redirect', this.nextRegisteredContest.alias);
  }
}
